import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

function load() {
  try {
    const v = JSON.parse(localStorage.getItem("bamf_cart") || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("bamf_cart", JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const add = (p) => {
      setItems((cur) => {
        const ex = cur.find((i) => i.slug === p.slug);
        if (ex) return cur.map((i) => (i.slug === p.slug ? { ...i, quantity: Math.min(i.quantity + 1, 50) } : i));
        return [...cur, { slug: p.slug, name: p.name, model: p.model, price: p.price, image: p.image, quantity: 1 }];
      });
      setOpen(true);
    };
    const setQty = (slug, q) =>
      setItems((cur) => (q <= 0 ? cur.filter((i) => i.slug !== slug) : cur.map((i) => (i.slug === slug ? { ...i, quantity: Math.min(q, 50) } : i))));
    const clear = () => setItems([]);
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const total = items.reduce((s, i) => s + (i.price || 0) * i.quantity, 0);
    return { items, add, setQty, clear, count, total, open, setOpen };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
